module.exports = __webpack_public_path__ + "static/assets/9d52473b0748c64f45803b663ebc6deb.svg";